import { BuilderComponentProps } from "../components/BuilderInterface";
import { BuildComponentKey } from "./types";
import BuilderButton from "../components/BuilderButton";
import BuilderText from "../components/BuilderText";
import BuilderIcon from "../components/BuilderIcon";
import BuilderDiv from "../components/BuilderDiv";
import BuilderPage from "../components/BuilderPage";
import BuilderPopup from "../components/BuilderPopup";
import BuilderImage from "../components/BuilderImage";
import BuilderProductQuantity from "../components/BuilderProductQuantity";
import BuilderGlobalBlockPrint from "../components/BuilderGlobalBlockPrint";
import BuilderOrderData from "../components/BuilderOrderData";
import BuilderDivider from "../components/BuilderDivider";
import { FC } from "react";

export const BuilderKeyMap: Partial<{ [key in BuildComponentKey]: (props: BuilderComponentProps) => React.ReactNode }> = {
    globalBlockPrint: BuilderGlobalBlockPrint,
    // globalBlockCFD: function (_: BuilderComponentProps<HTMLElement>): ReactNode {
    //     throw new Error("Function not implemented.");
    // },
    button: BuilderButton,
    text: BuilderText,
    icon: BuilderIcon,
    div: BuilderDiv,
    baseLayerPage: BuilderPage,
    baseLayerPopup: BuilderPopup,
    image: BuilderImage,
    cashButton: BuilderButton,
    printButton: BuilderButton,
    // receiptData: (props: BuilderComponentProps<HTMLElement>): ReactNode => (
    //     <BuilderReceipt {...props} receiptData={recieptSampleData} />
    // ),
    // cashLedgerData: (props: BuilderComponentProps<HTMLElement>): ReactNode => (
    //     <BuilderCashLedger {...props} cashLedgerData={CLSampleData} />
    // ),
    // eosData: (props: BuilderComponentProps<HTMLElement>): ReactNode => <BuilderEOS {...props} eosData={EOSSampleData} />,
    productQuantity: BuilderProductQuantity,
    tapToPay: BuilderButton,
    terminalButton: BuilderButton,
    customPayment: BuilderButton,
    homeMenuLink: BuilderButton,
    repeaterDiv: BuilderDiv,
    orderData: BuilderOrderData as unknown as FC<BuilderComponentProps<HTMLElement>>,
    divider: BuilderDivider
};
